var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v("Assign User Category")]),
        _c("div", { class: _vm.$style.subHeader }, [
          _vm._v("Select the category to be assigned to the selected users"),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c("div", { class: _vm.$style.table }, [
            _c("div", { class: _vm.$style.tableHead }, [
              _c("div", { class: _vm.$style.cell }, [_vm._v("User Name")]),
              _c("div", { class: _vm.$style.cell }, [_vm._v("Category")]),
              _c("div", { class: _vm.$style.cellAction }, [_vm._v("Actions")]),
            ]),
            _c(
              "div",
              { class: _vm.$style.tableBody },
              _vm._l(_vm.data.users, function (user) {
                return _c("div", { key: user.id, class: _vm.$style.row }, [
                  _c("div", { class: _vm.$style.cell }, [
                    _vm._v(
                      " " +
                        _vm._s(user.firstName) +
                        " " +
                        _vm._s(user.lastName) +
                        " "
                    ),
                  ]),
                  _c("div", { class: _vm.$style.cell }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.category(user.directoryViewId).name || "___"
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { class: _vm.$style.cellAction }, [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        class: _vm.$style.action,
                        on: {
                          click: function ($event) {
                            return _vm.drop(user.id)
                          },
                        },
                      },
                      [_vm._v("delete")]
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]),
          _c(
            "div",
            { class: _vm.$style.group },
            [
              _c(
                "rb-input",
                {
                  class: {
                    [_vm.$style.groupItem]: true,
                    rbInputEmpty: !_vm.data.view,
                  },
                  attrs: { "for-id": "view", error: _vm.$showError("view") },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("User Category"),
                    _c("i", [_vm._v("*")]),
                  ]),
                  _c("i", { staticClass: "material-icons icon" }, [
                    _vm._v("info"),
                  ]),
                  _c(
                    "rb-select",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "simple",
                      attrs: {
                        id: "view",
                        name: "view",
                        "data-vv-as": "User Category",
                      },
                      model: {
                        value: _vm.data.view,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "view", $$v)
                        },
                        expression: "data.view",
                      },
                    },
                    _vm._l(_vm.views, function (view) {
                      return _c(
                        "rb-option",
                        { key: view.id, attrs: { value: view.id } },
                        [_vm._v(" " + _vm._s(view.name) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _c("button", { staticClass: "rbButton mainButton" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
            _vm._v(" Save Changes "),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }